/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Dropdown, Form, Image, Row, Switch } from "antd";
import IconProposalContracts from "../../../../../atoms/CustomIcons/IconProposalContracts";
import { useForm } from "react-hook-form";
import {
  DeleteIcon,
  PencilIcon,
  PlusIcon,
} from "../../../../../atoms/CustomIcons";
import {
  InputField,
  InputNumberField,
  TextEditor,
} from "../../../../../atoms/FormFields";
import { MoreOutlined } from "@ant-design/icons";
import { PopUp } from "../../../../../atoms/PopUp";

import { useEffect, useState } from "react";
import ApprovalAndChangeOrderPopup from "./ApprovalAndChangeOrderPopup";
import { updateCompanySettings } from "../../ducks/services";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { getCompanyFieldsById } from "../../../TagsCategories/ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import ConfirmDelete from "../../../../../atoms/ConfirmDelete";

export default function ProposalsAndContracts({
  setLoading,
  loading,
}: {
  setLoading: (loading: boolean) => void;
  loading: boolean;
}) {
  const { control, handleSubmit, setValue } = useForm();

  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [isChangeOrderModalOpen, setIsChangeOrderModalOpen] = useState(false);

  const [potentialDealApproval, setPotentialDealApproval] = useState(false);
  const [changeOrderApproval, setChangeOrderApproval] = useState(false);
  const [changeOrderSending, setChangeOrderSending] = useState(false);
  const [contractRenewalNotify, setContractRenewalNotify] = useState(false);
  const [contractRenewalOverdue, setContractRenewalOverdue] = useState(false);
  const [instantQuotes, setInstantQuotes] = useState(false);
  const [automaticMark, setAutomaticMark] = useState(false);
  const [showEmailTemplateForm, setShowEmailTemplateForm] = useState(false);
  const [showTextTemplateForm, setShowTextTemplateForm] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];

  const settingsData = useAppSelector((state) => state?.tags?.tagData);

  const deleteTemplatePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Delete template?"
        paragraph="Are you sure you want to delete Template seasonal?"
        btnText="Delete template"
        btnApi={() => null}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  useEffect(() => {
    if (companyId && serviceLineId) {
      const payload = {
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId, serviceLineId]);

  useEffect(() => {
    if (settingsData) {
      const proposalApprovalData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "REQUIRE_PROPOSAL_APPROVAL_ENABLED"
      );
      const coApprovalData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "REQUIRE_CO_APPROVAL_ENABLED"
      );
      const coApprovalClientData: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "GET_CO_APPROVAL_FROM_CLIENT_ENABLED"
      );
      const contractRenewalNotify: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "NOTIFY_MANAGER_BEFORE_NEW_DAYS"
      );
      const contractRenewalOverdue: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS"
      );
      const instantQuotes: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "INSTANT_QUOTE_IN_THE_FIELD_ENABLED"
      );
      const automaticMark: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS"
      );
      const changeOrderSending: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "GET_CO_APPROVAL_FROM_CLIENT_ENABLED"
      );

      if (proposalApprovalData) {
        setPotentialDealApproval(proposalApprovalData?.value);
      }

      if (coApprovalData) {
        setChangeOrderApproval(coApprovalData?.value);
      }
      if (coApprovalClientData) {
        setChangeOrderApproval(coApprovalClientData?.value);
      }
      if (contractRenewalNotify) {
        setContractRenewalNotify(contractRenewalNotify?.value);
        setValue(
          "NOTIFY_MANAGER_BEFORE_NEW_DAYS",
          contractRenewalNotify?.value
        );
      }
      if (contractRenewalOverdue) {
        setContractRenewalOverdue(contractRenewalOverdue?.value);
        setValue(
          "KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS",
          contractRenewalOverdue?.value
        );
      }
      if (instantQuotes) {
        setInstantQuotes(instantQuotes?.value);
      }
      if (automaticMark) {
        setAutomaticMark(automaticMark?.value);
        setValue("MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS", automaticMark?.value);
      }
      if (changeOrderSending) {
        setChangeOrderSending(changeOrderSending?.value);
      }
    }
  }, [settingsData, setValue]);

  const onSubmit = (data: any) => {
    console.log("Form Data:", data);

    setLoading(true);
    const payload = [];

    if (potentialDealApproval) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "REQUIRE_PROPOSAL_APPROVAL_ENABLED",
        value: potentialDealApproval.toString(),
      });
    }
    if (data.MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS",
        value: data.MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS.toString(),
      });
    }
    if (instantQuotes) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "INSTANT_QUOTE_IN_THE_FIELD_ENABLED",
        value: instantQuotes.toString(),
      });
    }
    if (data.KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS",
        value: data.KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS.toString(),
      });
    }
    if (data.NOTIFY_MANAGER_BEFORE_NEW_DAYS) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "NOTIFY_MANAGER_BEFORE_NEW_DAYS",
        value: data.NOTIFY_MANAGER_BEFORE_NEW_DAYS.toString(),
      });
    }
    if (changeOrderSending) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "GET_CO_APPROVAL_FROM_CLIENT_ENABLED",
        value: changeOrderSending.toString(),
      });
    }
    if (changeOrderApproval) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "PROPOSAL_AND_CONTRACTS",
        name: "REQUIRE_CO_APPROVAL_ENABLED",
        value: changeOrderApproval.toString(),
      });
    }

    if (data)
      updateCompanySettings(payload)
        .then(() => {
          setLoading(false);
          SuccessMessage("Changes saved");
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/recreate_icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Create new from this template
        </Button>
      ),
    },

    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setIsApprovalModalOpen(false);
    }, 2000);
  };

  const approvalPopUp = {
    visibility: isApprovalModalOpen,
    content: (
      <ApprovalAndChangeOrderPopup
        title=""
        onClose={() => setIsApprovalModalOpen(false)}
        heading="Set proposal approval conditions"
        paragraph={
          <>
            Approval is required if{" "}
            <span style={{ color: "#6454F4" }}>any</span> of the following
            conditions are met. These rules apply to all managers unless
            customized for a specific manager.
          </>
        }
        btnText="Confirm"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 600,
    onCancel: () => setIsApprovalModalOpen(false),
  };

  const changeOrderPopUp = {
    visibility: isChangeOrderModalOpen,
    content: (
      <ApprovalAndChangeOrderPopup
        title=""
        onClose={() => setIsChangeOrderModalOpen(false)}
        heading="Set change order approval conditions"
        paragraph={
          <>
            Approval is required if{" "}
            <span style={{ color: "#6454F4" }}>any</span> of the following
            conditions are met. These rules apply to all managers unless
            customized for a specific manager.
          </>
        }
        btnText="Confirm"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 600,
    onCancel: () => setIsChangeOrderModalOpen(false),
  };

  return (
    <div style={{ width: "800px", margin: "0 auto" }}>
      <div>
        <h2 className="tabs_content_heading">
          <IconProposalContracts /> Proposals & Contracts
        </h2>
        <p className="tabs_content_subheading">
          Customize proposal and contract internal workflows.
        </p>
      </div>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_check.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Potential deal workflow steps </h3>
                <p>
                  Enable or disable the steps managers follow when handling
                  potential deals.
                </p>
              </div>
            </div>
          </div>

          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}> Approval </h4>
                <p style={{ marginBottom: "12px", color: "#6C7478" }}>
                  <span style={{ color: "#6454F4", fontWeight: "600" }}>
                    Branch manager
                  </span>
                  &nbsp; will need to approve estimate and proposal before it’s
                  sent to the customer.
                </p>
              </div>
              <div>
                <Switch
                  checked={potentialDealApproval}
                  onChange={setPotentialDealApproval}
                  disabled
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h5> Every proposal requires approval </h5>
              <Button
                htmlType="button"
                className="outlined-btn"
                type="primary"
                onClick={() => setIsApprovalModalOpen(true)}
                disabled
              >
                <PencilIcon /> Edit conditions
              </Button>
            </div>

            <div className="check_type_simple">
              <p>
                If approval isn’t always needed, you can set conditions for when
                it applies.
              </p>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_add_doc.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Change order workflow steps </h3>
                <p>
                  Enable or disable the steps managers follow when handling
                  contract change orders.
                </p>
              </div>
            </div>
          </div>

          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}> Approval </h4>
                <p style={{ marginBottom: "12px", color: "#6C7478" }}>
                  <span style={{ color: "#6454F4", fontWeight: "600" }}>
                    Branch manager
                  </span>
                  &nbsp; will need to approve change order before it goes
                  further.
                </p>
              </div>
              <div>
                <Switch
                  checked={changeOrderApproval}
                  onChange={setChangeOrderApproval}
                  disabled
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h5>
                Approval is required if ANY of the following conditions is met:{" "}
              </h5>
              <Button
                htmlType="button"
                className="outlined-btn"
                type="primary"
                onClick={() => setIsChangeOrderModalOpen(true)}
                disabled
              >
                <PencilIcon /> Edit conditions
              </Button>
            </div>

            <div className="check_type_simple">
              <p>Proposal amount exceeds $500,000</p>
            </div>
            <div className="check_type_simple">
              <p>If gross margin is below company target</p>
            </div>
          </div>

          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}>
                  Sending and client acceptance
                </h4>
                <p style={{ marginBottom: "12px", color: "#6C7478" }}>
                  If enabled, change orders must be sent and accepted by the
                  client before going to production.
                </p>
              </div>
              <div>
                <Switch
                  checked={changeOrderSending}
                  onChange={setChangeOrderSending}
                  disabled
                />
              </div>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_bell.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Contract renewal alerts </h3>
                <p>Customize timings on contracts renewals.</p>
              </div>
            </div>
          </div>

          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}>
                  Notify managers before renewal date
                </h4>
                <p style={{ marginBottom: "12px", color: "#6C7478" }}>
                  Remind managers X days before a contract ends so they can
                  prepare the new contract on time.
                </p>
              </div>
              <div>
                <Switch
                  checked={contractRenewalNotify}
                  onChange={setContractRenewalNotify}
                  disabled
                />
              </div>
            </div>

            <div className="send_in_check">
              Day before renewal:
              <InputNumberField
                fieldName="NOTIFY_MANAGER_BEFORE_NEW_DAYS"
                label=""
                control={control}
                defaultValue={0}
                iProps={{
                  placeholder: "Day before renewal",
                  min: 1,
                  disabled: true,
                }}
              />
              days
            </div>
          </div>

          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 style={{ marginBottom: "6px" }}>Renewal overdue</h4>
                <p style={{ marginBottom: "12px", color: "#6C7478" }}>
                  If a renewal is'nt created by the contract's end date. choose
                  how long to flag it as overdue. After that, the contracts is
                  treated as not renewed and renewal reminders stop.
                </p>
              </div>
              <div>
                <Switch
                  checked={contractRenewalOverdue}
                  onChange={setContractRenewalOverdue}
                  disabled
                />
              </div>
            </div>

            <div className="send_in_check">
              Keep overdue status for:
              <InputNumberField
                fieldName="KEEP_CONTRACT_RENEWAL_OVERDUE_DAYS"
                label=""
                control={control}
                defaultValue={0}
                iProps={{
                  placeholder: "Keep overdue status for",
                  min: 1,
                  disabled: true,
                }}
              />
              days
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "0px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_timer.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Instant quotes in the field </h3>
                <p>
                  Let crew leaders and technicians create proposals and invoices
                  directly from their mobile devices.
                </p>
              </div>
              <div>
                <Switch
                  checked={instantQuotes}
                  onChange={setInstantQuotes}
                  disabled
                />
              </div>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div className="icon_avatar">
                  <img
                    src="/images/settings/icon_mail.svg"
                    alt="customer management"
                  />
                </div>
                <div>
                  <h3> Email templates for proposals </h3>
                  <p>Create default email messages to send with proposals.</p>
                </div>
              </div>
              <div>
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  type="primary"
                  onClick={() => setShowEmailTemplateForm(true)}
                  disabled
                >
                  <PlusIcon /> Create
                </Button>
              </div>
            </div>
          </div>

          <div className="email_or_msg">
            {showEmailTemplateForm && (
              <div className="check_type">
                <div className="create_template">
                  <div className="title">
                    <p> Template name </p>
                    <Button
                      htmlType="button"
                      style={{ background: "transparent", padding: "0" }}
                      onClick={() => {
                        setIsDeleteModalOpen(true);
                      }}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                  <div className="template_body">
                    <Row gutter={[12, 12]}>
                      <Col span={24}>
                        <InputField
                          fieldName="email_temp_name"
                          label="Email template name"
                          control={control}
                          defaultValue=""
                          className="category_input mb_0"
                          iProps={{
                            placeholder: "Email template name",
                          }}
                          isRequired
                          rules={{
                            required: "Email template name is required.",
                          }}
                        />
                      </Col>

                      <Col span={24}>
                        <InputField
                          fieldName="email_temp_subject"
                          label="Email subject"
                          control={control}
                          defaultValue=""
                          className="category_input mb_0"
                          iProps={{
                            placeholder: "Email subject",
                          }}
                          isRequired
                          rules={{
                            required: "Email subject is required.",
                          }}
                        />
                      </Col>

                      <Col span={24}>
                        <TextEditor
                          fieldName="email_temp_text"
                          label="Email text"
                          control={control}
                          iProps={{
                            placeholder: "Compose your email template here...",
                          }}
                          className="customize_text_editor"
                        />
                      </Col>
                      <Col span={24}>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button style={{ width: "100%" }}>Cancel</Button>
                          <Button
                            style={{ width: "100%" }}
                            type="primary"
                            className="mint-btn"
                          >
                            Save changes
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            )}
            <div className="check_type">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  Template seasonal
                </span>

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "6px",
                      height: "auto",
                      background: "transparent",
                    }}
                    className="only_icon"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>
            </div>
            <div className="check_type">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  Proposal template annual
                </span>

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "6px",
                      height: "auto",
                      background: "transparent",
                    }}
                    className="only_icon"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div className="icon_avatar">
                  <img
                    src="/images/settings/cs_cursor.svg"
                    alt="customer management"
                  />
                </div>
                <div>
                  <h3> Text message templates for proposals </h3>
                  <p>Create default text messages to send with proposals.</p>
                </div>
              </div>
              <div>
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  type="primary"
                  onClick={() => setShowTextTemplateForm(true)}
                >
                  <PlusIcon /> Create
                </Button>
              </div>
            </div>
          </div>

          <div className="email_or_msg">
            {showTextTemplateForm && (
              <div className="check_type">
                <div className="create_template">
                  <div className="title">
                    <p> Template name </p>
                    <Button
                      htmlType="button"
                      style={{ background: "transparent", padding: "0" }}
                      onClick={() => {
                        setIsDeleteModalOpen(true);
                      }}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                  <div className="template_body">
                    <Row gutter={[12, 12]}>
                      <Col span={24}>
                        <InputField
                          fieldName="text_temp_name"
                          label="Text template name"
                          control={control}
                          defaultValue=""
                          className="category_input mb_0"
                          iProps={{
                            placeholder: "e.g. Maintenance standard template",
                          }}
                          isRequired
                          rules={{
                            required: "Text template name is required.",
                          }}
                        />
                      </Col>

                      <Col span={24}>
                        <TextEditor
                          fieldName="text_message_temp_text"
                          label="Text message"
                          control={control}
                          iProps={{
                            placeholder: "Write text message here",
                          }}
                          className="customize_text_editor"
                        />
                      </Col>
                      <Col span={24}>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button style={{ width: "100%" }}>Cancel</Button>
                          <Button
                            style={{ width: "100%" }}
                            type="primary"
                            className="mint-btn"
                          >
                            Save changes
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            )}
            <div className="check_type">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  Template seasonal
                </span>

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "6px",
                      height: "auto",
                      background: "transparent",
                    }}
                    className="only_icon"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>
            </div>
            <div className="check_type">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  Proposal template annual
                </span>

                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "6px",
                      height: "auto",
                      background: "transparent",
                    }}
                    className="only_icon"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>
            </div>
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar" style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/cross_circle.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Automatic mark idle potential deals as lost </h3>
                <p>
                  Change the status to <span> Lost </span> after X days of
                  inactivity in open potential deals. Does not apply to deals
                  with the status Accepted.
                </p>
              </div>
              <div>
                <Switch
                  checked={automaticMark}
                  onChange={setAutomaticMark}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="send_in_check">
            Mark inactive deals as lost in:
            <InputNumberField
              fieldName="MARK_IDLE_DEALS_AS_LOST_AFTER_DAYS"
              label=""
              control={control}
              defaultValue={0}
              iProps={{
                placeholder: "Mark inactive deals as lost in",
                min: 1,
                disabled: true,
              }}
            />
            days
          </div>
        </Card>

        <div style={{ textAlign: "right", width: "100%" }}>
          <Button
            htmlType="submit"
            className="mint-btn"
            style={{ marginTop: "10px" }}
            disabled
          >
            Save changes
          </Button>
        </div>
      </Form>

      <PopUp {...approvalPopUp} />
      <PopUp {...changeOrderPopUp} />
      <PopUp {...deleteTemplatePopUp} />
    </div>
  );
}
